export const accessOptions = [
  { label: 'Workspace Member', value: 'member' },
  { label: 'Dashboard', value: 'dashboard member' },
  { label: 'Insights', value: 'insights member' },
  { label: 'Journeys', value: 'journeys member' },
  { label: 'Projects', value: 'projects member' },
  { label: 'Risk Assessments', value: 'risk assessments member' },
  { label: 'Daily Labour', value: 'daily labour member' },
  { label: 'Engagement', value: 'engagement member' },
  { label: 'Communities', value: 'communities member' },
  { label: 'Incident Management', value: 'incident management member' },
]

export const roleOptions = [
  { label: 'Workspace Admin', value: 'administrator' },
  { label: 'Insights Manager', value: 'insights manager' },
  { label: 'Journey Manager', value: 'journey manager' },
  { label: 'Project Manager', value: 'project manager' },
  { label: 'Risk Manager', value: 'risk manager' },
  { label: 'Engagement Manager', value: 'engagement manager' },
  { label: 'Communities Manager', value: 'communities manager' },
  { label: 'Incident Manager', value: 'incident manager' },
]
